import { render, staticRenderFns } from "./NumberTextIcon.vue?vue&type=template&id=fcf22f8e&scoped=true"
import script from "./NumberTextIcon.vue?vue&type=script&lang=js"
export * from "./NumberTextIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf22f8e",
  null
  
)

export default component.exports